import { getImageProps, ImageProps } from 'next/image';

// O next/image adiciona style="color:transparent" no <img>, bloqueado pela CSP sem 'unsafe-inline'.
// Mantém o otimizador de imagens do Next, removendo só esse estilo.
export default function CspImage(props: ImageProps) {
  const { props: { style: _style, ...imgProps } } = getImageProps(props);

  // eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text
  return <img {...imgProps} />;
}
